import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface DeleteHashtagParams {
  id: string
}

const deleteHashtag = async ({ id }: DeleteHashtagParams): Promise<void> => {
  await api.delete(`/hashtag/${id}`)
}

export const useDeleteHashtag = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<void, Error, DeleteHashtagParams>({
    mutationFn: deleteHashtag,
    onSuccess: async (_, variables) => {
      showSuccessToast(t('toast.success'), t('toast.hashtagDeleted'))
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['hashtags'] }),
        queryClient.invalidateQueries({ queryKey: ['hashtag', variables.id] }),
        queryClient.invalidateQueries({ queryKey: ['hashtag-contacts', { id: variables.id }] }),
      ])
    },
  })
}

